import {
	Box,
	Button,
	FormControlLabel,
	Switch,
	Typography,
} from '@mui/material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Modal from '../../components/Modal'
import { useGraphConf } from '../../hooks/useLocalConfig'
import { getHouse } from '../../store/HouseById/selectors'
import EditSettingFrom from './EditSettingFrom'

type Props = {
	houseId: number
}
function SettingTab(props: Props) {
	const house = useSelector((s) => getHouse(s, props.houseId))
	const [modalOpen, setModalOpen] = useState<boolean>(false)
	const [debugPanelOpen, setDebugPanelOpen] = useState<boolean>(false)
	const { enabledGraphV2, setEnabledGraphV2 } = useGraphConf()

	return (
		<div>
			<Typography variant="h6" style={{ flex: 1 }}>
				ハウス名: {house.name}
			</Typography>
			<label>
				<Box>
					<FormControlLabel
						control={
							<Switch
								onClick={() => setEnabledGraphV2(!enabledGraphV2)}
							></Switch>
						}
						label="グラフv2"
						labelPlacement="end"
						checked={enabledGraphV2 || false}
					/>
				</Box>
			</label>
			<Button
				onClick={() => {
					setModalOpen(true)
				}}
			>
				編集する
			</Button>
			<Modal open={modalOpen} closeModal={() => setModalOpen(false)}>
				<EditSettingFrom houseId={house.id} />
			</Modal>

			{/* Debug Panel */}
			<Box
				sx={{
					marginTop: 4,
					padding: 2,
					backgroundColor: '#f5f5f5',
					borderRadius: 1,
					border: '1px solid #ddd',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						cursor: 'pointer',
					}}
					onClick={() => setDebugPanelOpen(!debugPanelOpen)}
				>
					<Typography variant="h6">デバッグ情報</Typography>
					<Typography variant="body2" sx={{ color: '#666' }}>
						{debugPanelOpen ? '▼' : '▶'}
					</Typography>
				</Box>

				{debugPanelOpen && (
					<Box
						sx={{
							marginTop: 2,
							backgroundColor: '#fff',
							padding: 2,
							borderRadius: 1,
							fontFamily: 'monospace',
							fontSize: '12px',
							overflowX: 'auto',
						}}
					>
						<Typography variant="subtitle2" fontWeight="bold" gutterBottom>
							House Entity:
						</Typography>
						<pre
							style={{
								margin: 0,
								whiteSpace: 'pre-wrap',
								wordBreak: 'break-word',
							}}
						>
							{JSON.stringify(house, null, 2)}
						</pre>
					</Box>
				)}
			</Box>
		</div>
	)
}

export default SettingTab
